// extracted by mini-css-extract-plugin
module.exports = {"header__navigation__desktop-side-menu__upgrade":"SideMenu_header__navigation__desktop-side-menu__upgrade__2QQ6p","link":"SideMenu_link__sC9hi"};